import $ from 'jquery';
import {merge} from 'lodash';
import AuthHeader from '../../helpers/AuthHeader';
import config from '../../config/config';

export const searchService = {
    autocomplete
};

function _autocomplete(search_input, search_types) {
    if(typeof search_types === 'string')
        search_types = [search_types];
    let headers = AuthHeader({'Content-Type': 'application/json'}),
        baseUrl = `${config.apis.v2_sales}/search`,
        requestOptions = {
            method: 'POST',
            headers,
            body: JSON.stringify({search_input, search_types: search_types.join(',')})
        };

    return fetch(baseUrl, requestOptions)
        .then(res=>res.json());
}


function autocomplete(search_input, search_types, batch, async=false, milestonesOnly = false) {
    return true || config.live ? (batch? autocompleteBatchLive(search_input, search_types, async, milestonesOnly) : autocompleteLive(search_input, search_types, batch, milestonesOnly)) : autocompleteStatic(batch);
}

function autocompleteLive(search_input, search_types, batch, milestonesOnly) {
    
//    if(typeof search_types === 'array')
    search_types = search_types.join(',');
    let headers = AuthHeader({'Content-Type': 'application/json'}),
      baseUrl = `${config.apis.miniCat}/v2/search${batch?'/batch':''}`,
      qs = {
        search_input,
        search_types
      },
      requestOptions = {
        method: 'GET',
        headers,
      };
        
    if(milestonesOnly)
      qs.scope = 'milestones';
    
    baseUrl += '?' +  $.param(qs);
    
    return fetch(baseUrl, requestOptions)
        .then(res=>res.json());
}

function autocompleteBatchLive(search_input, search_types, async=false) {
    if(typeof search_types === 'array')
        search_types = search_types.join(',');
  let headers = AuthHeader({'Content-Type': 'application/json'}),
      baseUrl = `${config.apis.miniCat}/v2/search/batch${async?'?async=true':''}`,
      requestOptions = {
          method: 'POST',
          headers,
          body: JSON.stringify({search_input, search_types: search_types.join(',')})
      };

  return fetch(baseUrl, requestOptions)
      .then(res=>res.json());
}


function autocompleteStatic(batch) { 
    let baseUrl = `${config.apis.sales}/api/static/search_multi${batch?'_batch':''}.json`;
    return fetch(baseUrl)
    .then(res=>{   
        return res.json()
    });
}

/*
function autocomplete(search_input, search_types, force) {
    return true || config.live ? autocompleteLive(search_input, search_types, force) : autocompleteStatic();
}

function autocompleteLive(search_input, search_types, force) {
    
//    if(typeof search_types === 'array')
	let entities = Object.assign([], search_types);
	if(entities.includes('projects') && !entities.includes('products'))
		entities.push('products');
	
	entities = entities.join(',');
    let headers = AuthHeader({'Content-Type': 'application/json'}),
        baseUrl = `${config.apis.miniCat}/v2/search?search_input=${encodeURIComponent(search_input)}&search_types=${encodeURIComponent(entities)}&source=statements${force?'&force=true':''}`,
        requestOptions = {
            method: 'GET',
            headers,
//            body: JSON.stringify({search_input, search_types: search_types.join(',')})
        };

    return fetch(baseUrl, requestOptions)
        .then(res=>res.json());
}

function autocompleteStatic() { 
    let baseUrl = `${config.apis.sales}/api/static/search_sec.json`;
    return fetch(baseUrl)
    .then(res=>{   
        return res.json()
    });
}
*/